




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_altinnTaxInvoicePreviews, GQL_altinnTaxInvoicePreviews_altinnTaxInvoicePreviews, GQL_altinnTaxInvoicePreviewsVariables } from '@/queries/__generated__/altinnTaxInvoicePreviews';
import { IErrors, hasCode } from '@/utils/graphql-errors';
import AltinnTaxInvoicePreview from './AltinnTaxInvoicePreview.vue';
import AltinnSendTaxToFakturabankButton from './AltinnSendTaxToFakturabankButton.vue';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_ameldingsForTaxInvoices } from '@/queries/__generated__/ameldingsForTaxInvoices';
import gql from 'graphql-tag';

const ALTINN_TAX_INVOICE_PREVIEWS = gql`
  query altinnTaxInvoicePreviews($calendarMonth: String!) {
    altinnTaxInvoicePreviews(calendarMonth: $calendarMonth) {
      type
      companyName
      organizationNumber
      calendarMonth
      altinnReference
      taxCollectorUnit {
        id
        name
        highestPriorityIdentity {
          id
          value
        }
      }
      messages {
        deliveredAt
        altinnReference
        receivers
        replacedByAltinnReference
        amount
      }
      bban
      kid
      dueDate
      amount
    }
  }
`;

const AMELDINGS_FOR_TAX_INVOICES_PAGE = gql`
  query ameldingsForTaxInvoices($calendarMonth: String!, $unitId: ID!) {
    ameldings(calendarMonth: $calendarMonth, unitId: $unitId) {
      id
      humanStatus
    }
  }
`;

@Component({
  components: {
    AltinnTaxInvoicePreview,
    AltinnSendTaxToFakturabankButton,
  },
})
export default class AltinnTaxInvoicePreviews extends Vue {
  @Prop({ type: String, required: true }) private calendarMonth!: string;

  @SmartQuery<AltinnTaxInvoicePreviews, GQL_altinnTaxInvoicePreviews, GQL_altinnTaxInvoicePreviewsVariables>({
    query: ALTINN_TAX_INVOICE_PREVIEWS,
    fetchPolicy: 'no-cache',
    skip() { return !this.calendarMonth },
    variables() { return { calendarMonth: this.calendarMonth } },
    error(error: IErrors) {
      if (hasCode(error, 'NO_FEEDBACK_XML')) {
        this.$sMessage.error(this.$t('AltinnTax.noFeedbackXml'));
        this.$router.push({ name: 'Ameldings' });

        // Because for some reason this is called twice
        this.$destroy();
      }
    },
  }) private altinnTaxInvoicePreviews!: GQL_altinnTaxInvoicePreviews_altinnTaxInvoicePreviews[];

  @SmartQuery({ query: CURRENT_UNIT }) private currentUnit!: GQL_currentUnit_currentUnit;

  @SmartQuery<AltinnTaxInvoicePreviews, GQL_ameldingsForTaxInvoices>({
    query: AMELDINGS_FOR_TAX_INVOICES_PAGE,
    fetchPolicy: 'no-cache',
    skip() { return !this.calendarMonth || !this.currentUnit },
    variables() {
      return {
        calendarMonth: this.calendarMonth,
        unitId: this.currentUnit.id,
      };
    },
    update(data) {
      return data.ameldings.some(amelding => amelding.humanStatus === 'FEEDBACK_READY' || amelding.humanStatus === 'PENDING');
    },
  }) private hasPending = false;


  private get employerTaxPreview(): GQL_altinnTaxInvoicePreviews_altinnTaxInvoicePreviews {
    return this.altinnTaxInvoicePreviews.find(p => p.type === 'employer')!;
  }

  private get incomeTaxPreview(): GQL_altinnTaxInvoicePreviews_altinnTaxInvoicePreviews {
    return this.altinnTaxInvoicePreviews.find(p => p.type === 'income')!;
  }

  private get garnishmentPreview(): GQL_altinnTaxInvoicePreviews_altinnTaxInvoicePreviews | undefined {
    return this.altinnTaxInvoicePreviews.find(p => p.type === 'garnishment');
  }

  private get garnishmentSamordnetPreview(): GQL_altinnTaxInvoicePreviews_altinnTaxInvoicePreviews | undefined {
    return this.altinnTaxInvoicePreviews.find(p => p.type === 'garnishment_samordnet');
  }
}

